import { Component, OnInit, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BackendService } from '../../../api/bff/backend.service';
import { AnalyticsData } from '@shared/interfaces/analytics';
import { AnalyticsStatsComponent } from './analytics-stats/analytics-stats.component';
import { AnalyticsVisitorsComponent } from './analytics-visitors/analytics-visitors.component';
import { AnalyticsPageViewsComponent } from './analytics-page-views/analytics-page-views.component';
import { AnalyticsPageUsageComponent } from './analytics-page-usage/analytics-page-usage.component';
import { CardComponent } from '../../../components/card/card.component';
import { RangeFormComponent } from '../../../components/range-form/range-form.component';
import { DateRange, getDaysBetween } from '../../../utils/dayjs/dayjs';

@Component({
  selector: 'app-analytics',
  imports: [
    AnalyticsStatsComponent,
    AnalyticsVisitorsComponent,
    AnalyticsPageViewsComponent,
    AnalyticsPageUsageComponent,
    CardComponent,
    RangeFormComponent,
  ],
  templateUrl: './analytics.component.html',
  styleUrl: './analytics.component.css',
})
export class AnalyticsComponent implements OnInit {
  private backend = inject(BackendService);

  protected data = signal<AnalyticsData | null>(null);
  protected period = signal('');
  protected filterRanges = [
    { value: 30, label: $localize`Last 30 days` },
    { value: 365, label: $localize`Last 12 months` },
  ];

  async ngOnInit() {
    this.data.set(await firstValueFrom(this.backend.getAnalytics(30)));
    this.setPeriod(30);
  }

  protected async onRangeChange({ start, end }: DateRange) {
    const period = getDaysBetween(start, end);
    this.data.set(await firstValueFrom(this.backend.getAnalytics(period)));
    this.setPeriod(period);
  }

  private setPeriod(period: number) {
    if (period === 0) {
      this.period.set($localize`Since launch`);
    } else if (period === 30) {
      this.period.set($localize`Last 30 days`);
    } else {
      this.period.set($localize`Last 12 months`);
    }
  }
}
